import { toast } from "react-toastify";
import ConnectIpsServices from "../services/connectIpsServices";
// import ConnectIpsServices from "./ConnectIpsServices";

export const submitConnectIpsForm = async (tokenResponse) => {
console.log("🚀 ~ submitConnectIpsForm ~ tokenResponse:", tokenResponse)
//   console.log("🚀 ~ submitConnectIpsForm ~ orderId:", orderId)
  try {
    // const tokenResponse =
    //   await ConnectIpsServices.getConnectIpsToken(orderId, orgcode);
    // console.log("🚀 ~ submitConnectIpsForm ~ tokenResponse:", tokenResponse)

    const data = tokenResponse.result;

    const formData = {
      MERCHANTID: data.merchantId,
      APPID: data.appId,
      APPNAME: data.appName,
      TXNID: data.txnId,
      TXNDATE: data.txnDate.split(" ")[0],
      TXNCRNCY: data.txnCrncy,
      TXNAMT: data.txnAmt,
      REFERENCEID: data.referenceId,
      REMARKS: data.remarks,
      PARTICULARS: data.particulars,
      TOKEN: data.token,
    };
    console.log("🚀 ~ submitConnectIpsForm ~ formData:", formData)

    const form = document.createElement("form");
    form.method = "POST";
    form.action = "https://uat.connectips.com/connectipswebgw/loginpage";

    Object.entries(formData).forEach(([key, value]) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = key;
      input.value = value;
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  } catch (error) {
    console.error(error);
    toast.error("ConnectIPS payment failed");
  }
};
